export default __webpack_public_path__ + "static/media/09_photo.d79a0777.jpg";